import React from 'react';

export function useLocalStorage () {
    const prefix = "@mobi/";

    const getName = React.useCallback((name: string) => `${prefix}${name}`, []);
    
    const set = React.useCallback((name: string, value: string) => {
        localStorage.setItem(getName(name), value);
    }, [getName]);

    const get = React.useCallback((name: string) => {
        return localStorage.getItem(getName(name));
    }, [getName]);

    const remove = React.useCallback((name: string) => {
        localStorage.removeItem(getName(name));
    }, [getName]);

    const exists = React.useCallback((name: string) => {
        return get(name) !== null;
    }, [get]);

    const clear = React.useCallback(() => {
        localStorage.clear();
    }, []);

    const setObject = React.useCallback(function <T = object>(name: string, value: T) {
        set(name, JSON.stringify(value));
    }, [set]);

    const getObject = React.useCallback(function <T = object>(name: string) {
        const v = get(name);
        return v !== null ? JSON.parse(v) as T : null;
    }, [get]);

    return React.useMemo(() => ({
        set, get, remove, exists, clear, setObject, getObject
    }), [exists, get, remove, set, clear, setObject, getObject]);
}